import { convertToCNSPolyMesh } from '../../translators/bingeom';
import { getOrFetchBinary, getHash } from '../../modules/assets';

const Mesh = {
  schema: {
    geometry: { type: 'File', label: 'PolyMesh Geometry File' },
  },

  update: function (operator, primitive, { node, store, properties, previousResult, loaded }) {
    const visible = properties.visible;
    const geom = operator.geometry; // Request geometry so the asset gets referenced
    const fetch = visible || (properties.prefetch && loaded);
    const ref = fetch && geom;
    const bingeom = ref && store.hasApi() && getOrFetchBinary(ref)(store);
    const mesh = bingeom && convertToCNSPolyMesh(bingeom, ref);
    //console.log('Mesh update', 'visible:', visible, 'prefetch:', properties.prefetch, 'fetch:', fetch, 'bingeom:', !!bingeom,  node.name, mesh);
    primitive.mesh = mesh;
    primitive.previousMesh = previousResult && previousResult.mesh;
    return primitive;
  },
};

export default Mesh;




// WEBPACK FOOTER //
// ./src/operators/PolyMesh/Mesh.js